import { render, staticRenderFns } from "./ExamCreation.vue?vue&type=template&id=6f1ccc2b&scoped=true"
import script from "./ExamCreation.vue?vue&type=script&lang=js"
export * from "./ExamCreation.vue?vue&type=script&lang=js"
import style0 from "./ExamCreation.vue?vue&type=style&index=0&id=6f1ccc2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ccc2b",
  null
  
)

export default component.exports